<template>
  <div class="c-product-bundle-card">
    <card-image
      v-if="featuredImage"
      class="c-product-bundle-card__image"
      :class="{
        'c-product-bundle-card__image--hide': hover
      }"
      :src="featuredImage.src"
      :alt="featuredImage.alt"
      aria-hidden="true"
      size="300x300"
    />
    <div class="c-product-bundle-card__content">
      <div class="l-grid l-grid--1-col-first-long l-grid--align-start">
        <div class="c-product-bundle-card__content__overview">
          <h1
            class="t-heading-5 u-margin-bottom-xx-small"
          >
            {{ product | title }}
          </h1>
          <product-info-description
            :product="product"
          />
        </div>
        <div class="c-product-bundle-card__content__sizepicker">
          <div class="l-flex l-flex--justify-between">
            <h2
              class="t-heading-6 u-margin-bottom-xx-small"
            >
              Select Ring Size
            </h2>
            <btn
              type="link"
              custom-color="#e9b419"
              @click="$emit('modal:open')"
            >
              Find My Ring Size
            </btn>
          </div>
          <select-input
            v-model="selectedSize"
            :options="sizeValues"
            class="u-margin-bottom-small"
          />
          <btn
            v-if="showEngraving"
            type="primary-open"
            :button-size="['thin', 'large']"
            :is-disabled="engravingDisabled"
            class="u-margin-bottom-small"
            @click="startEngraving"
          >
            <span> Add Engraving - </span>
            <product-price
              :price="finalEngravingPrice"
              :compare-at-price="engravingCompareAtPrice"
            />
          </btn>
          <btn
            class="c-product-bundle-card__content__sizepicker--button u-all-caps"
            type="primary-open"
            :is-disabled="isEdit"
            @click="bundleSelected"
          >
            {{ optionSelectLabel }}
          </btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardImage from './CardImage'
import ProductInfoDescription from '../productInfo/ProductInfoDescription.vue'
import ProductPrice from '../productPrice/ProductPrice.vue'
//import CircleSelect from '../dropdown/CircleSelect'
import Dropdown from '../dropdown/Dropdown'
import getEngravingPrice from '@/mixins/getEngravingPrice'
import get from 'lodash/get'
import Btn from '../button/Btn'
import isString from 'lodash/isString'

export default {
  name: "ProductBundleCard",
  filters: {
    title(product) {
      return get(product, 'title')
    }
  },
  components: {
    CardImage,
    ProductInfoDescription,
    //SelectInput: CircleSelect,
    SelectInput: Dropdown,
    Btn,
    ProductPrice
  },
  mixins:[
    getEngravingPrice,
  ],
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    bundle: {
      type: Object,
      default: () => ({}),
    },
    activeOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return { 
      selectedSize: null,
      hover: null,
      selectedVariant: null
    }
  },
  computed: {
    isEdit() {
      return !isString(this.selectedSize)
    },
    optionSelectLabel() {
      return this.isEdit ? 'Select a size' : 'Add to bundle'
    },
    featuredImage () {
      let result = get(this.product, 'featuredImage')
      if (!result && (process.env.NODE_ENV === 'debug')) {
        console.warn('[Product Card]: Invalid or missing featured Image!')
      }
      return result
    },
    sizeValues () {
      const product = this.product
      const activeOptions = this.activeOptions
      let result = []
      for (let activeOption of activeOptions) {
        if (
          activeOption.product &&
          product && product.id &&
          (activeOption.product.id === product.id)
        ) {
          //console.log({ activeOption, product })
          result = activeOption.sizes
          break
        }
      }
      return result
    },
    showEngraving() {
      const product = this.product
      return !!get(product, 'metafieldsMap.engraving')
    },
    engravingDisabled() {
      const selectedVariant = this.selectedVariant
      return selectedVariant ? !selectedVariant.availableForSale : true
    },
    finalEngravingPrice() {
      const bundle = this.bundle
      let result = this.engravingPrice
      let freeEngraving = bundle.tags.includes('free-bundle-engraving')
      if(freeEngraving) {
        result = 'Free'
      }
      return result
    }
  },
  watch: {
    selectedSize(value) {
      for(let variant of this.product.variants) {
        let sizeObj
        for(let option of variant.selectedOptions) {
          if(option.name === 'Size') {
            sizeObj = option
            break
          }
        }
        if(sizeObj && sizeObj.value === value) {
          this.selectedVariant = variant
          break
        }
      }
    }
  },
  methods: {
    bundleSelected() {
      if (this.selectedSize) {
        const product = this.product
        this.$emit('update:selection', {
          bundleType: product.bundleType,
          event: this.selectedSize,
          product
        })
      }
    },
    startEngraving() {
      if (this.selectedVariant) {
        const product = this.product
        let engravingData = {
          bundleType: product.bundleType,
          event: this.selectedSize,
          product,
          variant: this.selectedVariant,
          size: this.selectedSize,
          isBundle: true
        }
        this.$emit("engraving", engravingData);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.u-all-caps {
  text-transform: uppercase;
}
.c-product-bundle-card {
  text-align: left;
  width: 100%;
  display: flex;
  @include respond(tab-port) {
    flex-direction: column;
  }

  &__image {
    max-height: 60%;
    margin-bottom: 0;
    margin: rem(20px) rem(30px);
    position: relative;
    opacity: 1;
    transition: 0.5s;
    @include respond(tab-port) {
      margin-left: auto;
      margin-right: auto;
    }
    @include respond(phone) {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0;
      height: rem(150px);
      width: rem(150px);
    }
  }

  &__content {
    max-height: 60%;
    margin: 20px 30px;
    &__overview {
      width: 100%;
      @include themify($themes) {
        border-bottom: $border themed("foreground", "section-border");
      }
    }
    &__sizepicker {
      &--button {
        width: 100%;
      }
    }
  }
}
</style>
